import { Route, Redirect } from "react-router-dom";
import { RouteProps } from "react-router";

import { useAppSelector } from "../store/hooks";
import CustomLoadingOverlay from "./CustomLoadingOverlay";

const PrivateRoute = (routeProps: RouteProps) => {
  const loading = useAppSelector((state) => state.auth.loading);
  const isAuth = useAppSelector((state) => state.auth.isAuth);

  if (loading) return <CustomLoadingOverlay active fullHeight />;

  return isAuth ? (
    <Route {...routeProps} />
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  );
};

export default PrivateRoute;
